export default "__VITE_PUBLIC_ASSET__d9bca396__"